import type {
  CustomFieldOptionViewModel,
  CustomFieldType,
  CustomFieldViewModel,
} from '../models/custom-field.model';
import {
  CODE_FORMAT_DEFAULT,
  CODE_LENGTH_DEFAULT,
  CODE_PREFIX_DEFAULT,
  CODE_SEPARATOR_DEFAULT,
} from './code-field.util';
import { RATING_LEVELS_DEFAULT } from './rating-field.util';

export const CUSTOM_FIELD_TYPE_OPTIONS: Array<{ value: CustomFieldType; label: string }> = [
  { value: 'TEXT', label: 'Text' },
  { value: 'LONG_TEXT', label: 'Long Text' },
  { value: 'NUMBER', label: 'Number' },
  { value: 'DATE', label: 'Date' },
  { value: 'BOOLEAN', label: 'Boolean' },
  { value: 'SELECT', label: 'Select' },
  { value: 'ROW_COLOR', label: 'Row color' },
  { value: 'CURRENCY', label: 'Currency' },
  { value: 'PROGRESS', label: 'Progress' },
  { value: 'PERSON', label: 'Person' },
  { value: 'PHONE', label: 'Phone' },
  { value: 'EMAIL', label: 'Email' },
  { value: 'FILE', label: 'File' },
  { value: 'LABELS', label: 'Labels' },
  { value: 'FORMULA', label: 'Formula' },
  { value: 'RATING', label: 'Rating' },
  { value: 'CODE', label: 'Code' },
  { value: 'DATETIME', label: 'DateTime' },
  { value: 'TIME', label: 'Time' },
  { value: 'CONFIRMATION_DATE', label: 'Confirmation with date' },
  { value: 'ITEM_LIST', label: 'Item list' },
];

export function createEmptyCustomField(order: number): CustomFieldViewModel {
  return {
    fieldId: '',
    key: null,
    name: '',
    type: 'TEXT',
    required: false,
    readOnly: false,
    showInQuickView: false,
    showInApp: false,
    placeholder: '',
    order,
    options: [],
    formulaDefinition: null,
    formulaResultDecimalPlaces: 0,
    numberDecimalPlaces: 0,
    numberShowPercentSuffix: false,
    ratingLevels: RATING_LEVELS_DEFAULT,
    codePrefix: CODE_PREFIX_DEFAULT,
    codeFormat: CODE_FORMAT_DEFAULT,
    codeLength: CODE_LENGTH_DEFAULT,
    codeSeparator: CODE_SEPARATOR_DEFAULT,
    projectReusableFieldId: null,
    fromProjectReusable: false,
    personRestrictToWorkflowMembers: false,
    collectViaWhatsApp: false,
    whatsAppPrompt: null,
    whatsAppCollectionOrder: null,
  };
}

export function createEmptyFieldOption(order: number): CustomFieldOptionViewModel {
  return {
    id: '',
    label: '',
    value: '',
    colorHex: '#E2E8F0',
    order,
  };
}

export function normalizeFieldOptions(
  options: CustomFieldOptionViewModel[]
): CustomFieldOptionViewModel[] {
  return options.map((option, index) => ({
    ...option,
    id: option.id || `opt-${index + 1}`,
    value: '',
    colorHex: option.colorHex || '#E2E8F0',
    order: index + 1,
  }));
}
